import componentPackPcNotice from '../ui-components/pcnotice';
import componentPackPcSwiper from '../ui-components/pcswiper';
import componentPackPcNavbar from '../ui-components/pcnavbar';
import componentPackPcGoodslist from '../ui-components/pcgoodslist';
import componentPackPcFooter from '../ui-components/pcfooter';
import componentPackPcBanner from '../ui-components/pcbanner';
import componentPackPcMenubar from '../ui-components/pcmenubar';
import componentPackSpacing from '../ui-components/pcspacing';
import componentPackNews from '../ui-components/pcnews/';
import config from '@/config';
import VueI18n from 'vue-i18n';
import messages from '@/pages/design/design_i18n';

// const messages = require('@/pages/design/design_i18n')

var i18n = new VueI18n({
  locale: window.localStorage.lang || config.lang,
  messages: messages.messages
});

/**
 * hidden 隐藏，不显示在工具栏
 * maxNum Number 最大可配置数
 * topDisplay Bool 最顶部显示
 * bottomDisplay Bool 最底部显示
 * onlyCanConfig Bool 是否只能配置数据，不能删除 copy
 * @type {*[]}
 */
var tools = [{
  groupName: i18n.t('left.publicComponent'),
  componentList: [{
    title: i18n.t('left.notice'),
    maxNum: 1,
    order: 1,
    draggable: false,
    icon: 'el-icon-picture',
    name: 'Notice',
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackPcNotice
  }, {
    title: i18n.t('left.navbar'),
    maxNum: 1,
    order: 2,
    draggable: false,
    icon: 'el-icon-picture',
    name: 'Navbar',
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackPcNavbar
  }, {
    title: i18n.t('left.swiper'),
    maxNum: 50,
    icon: 'el-icon-picture',
    name: 'Swiper',
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackPcSwiper
  }, {
    title: i18n.t('left.banner'),
    maxNum: 50,
    icon: 'el-icon-picture',
    name: 'Banner',
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackPcBanner
  }, {
    title: i18n.t('left.goodslist'),
    maxNum: 50,
    icon: 'el-icon-picture',
    name: 'Goodslist',
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackPcGoodslist
  }, {
    title: i18n.t('left.news'),
    maxNum: 50,
    icon: 'el-icon-picture',
    name: 'News',
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackNews
  }, {
    title: i18n.t('left.spacing'),
    maxNum: 50,
    name: 'Spacing',
    key: 10,
    platform: 'pc',
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackSpacing
  }]
}, {
  groupName: i18n.t('left.pcComponent'),
  componentList: [{
    title: i18n.t('left.pcmenubar'),
    maxNum: 1,
    order: 3,
    draggable: false,
    icon: 'el-icon-picture',
    name: 'Menubar',
    platform: 'pc',
    type: 'PC',
    componentPack: componentPackPcMenubar
  }, {
    title: i18n.t('left.pcfooter'),
    maxNum: 1,
    draggable: false,
    order: 'footer',
    icon: 'el-icon-picture',
    name: 'Footer',
    platform: 'pc',
    type: 'PC',
    componentPack: componentPackPcFooter
  }]
}];
export default tools;